"use strict";

exports.__esModule = true;
exports["default"] = ControlClose;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ControlClose(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.438 15.884L31.175 3.149a1.806 1.806 0 0 0 .002-2.554 1.801 1.801 0 0 0-2.554.003L15.886 13.333 3.147.593A1.807 1.807 0 0 0 .592.59a1.803 1.803 0 0 0 .003 2.555l12.739 12.739L.595 28.623a1.797 1.797 0 0 0 0 2.552 1.803 1.803 0 0 0 2.55 0l12.741-12.739 12.736 12.737a1.805 1.805 0 0 0 2.552-2.552L18.438 15.884z"
  }));
}